import * as CommonSelectors from "@mapbox/mapbox-gl-draw/src/lib/common_selectors";
import doubleClickZoom from "@mapbox/mapbox-gl-draw/src/lib/double_click_zoom";
import * as Constants from "mapbox-gl-draw-geodesic/src/constants";
import { createCircle } from "mapbox-gl-draw-geodesic/src/utils/circle_geojson";
import { bearing } from "mapbox-gl-draw-geodesic/src/utils/geodesy";
import createGeodesicGeojson from "mapbox-gl-draw-geodesic/src/utils/create_geodesic_geojson";
import dragPan from "mapbox-gl-draw-geodesic/src/utils/drag_pan";
import pinia, { useMap } from "@/services";

const DrawRadiusCircle = {};

DrawRadiusCircle.onSetup = function () {
  this.clearSelectedFeatures();
  doubleClickZoom.disable(this);
  dragPan.disable(this);
  this.updateUIClasses({ mouse: Constants.cursors.ADD });
  this.setActionableState(); // default actionable state is false for all actions
  return {};
};

DrawRadiusCircle.onMouseDown = DrawRadiusCircle.onTouchStart = function (
  state,
  e
) {
  if (state.circle) {
    this.deleteFeature([state.circle.id], { silent: true });
  }
  const center = [e.lngLat.lng, e.lngLat.lat];
  const circle = this.newFeature(createCircle(center, Number.EPSILON));
  this.addFeature(circle);
  state.circle = circle;
  state.circle.properties[Constants.properties.CIRCLE_RADIUS] =
    useMap(pinia).circleRadius / 1e3; // <= link state distance here

  state.circle[Constants.properties.CIRCLE_HANDLE_BEARING] = bearing(center, [
    center[0] + 1,
    center[1],
  ]);
  state.circle.changed();
  this.map.fire(Constants.events.CREATE, {
    features: [state.circle.toGeoJSON()],
  });
  this.changeMode(Constants.modes.SIMPLE_SELECT, {
    featureIds: [state.circle.id],
  });
  useMap(pinia).editingMode = {
    ...useMap(pinia).editingMode,
    mode: "direct_select",
  };
};

DrawRadiusCircle.onKeyUp = function (state, e) {
  if (CommonSelectors.isEscapeKey(e)) {
    if (state.circle) {
      this.deleteFeature([state.circle.id], { silent: true });
    }
    this.changeMode(Constants.modes.SIMPLE_SELECT);
  } else if (CommonSelectors.isEnterKey(e)) {
    this.changeMode(Constants.modes.SIMPLE_SELECT, {
      featureIds: [state.circle.id],
    });
  }
};

DrawRadiusCircle.onStop = function () {
  this.updateUIClasses({ mouse: Constants.cursors.NONE });
  doubleClickZoom.enable(this);
  dragPan.enable(this);
  this.activateUIButton();
};

DrawRadiusCircle.toDisplayFeatures = function (state, geojson, display) {
  if (state.circle) {
    const isActivePolygon = geojson.properties.id === state.circle.id;
    geojson.properties.active = isActivePolygon
      ? Constants.activeStates.ACTIVE
      : Constants.activeStates.INACTIVE;
  }

  const displayGeodesic = (gj) => {
    const geodesicGeojson = createGeodesicGeojson(gj, { ctx: this._ctx });
    geodesicGeojson.forEach(display);
  };

  displayGeodesic(geojson);
};

export default DrawRadiusCircle;
